/**
 * Route and metadata of the free risk matrix calculator (SEO plan Workstream E
 * row 7). Shared by the page, the /free hub, the sitemap and the tests.
 */
export const RISK_MATRIX_PATH = "/free/risk-matrix-calculator";
export const RISK_MATRIX_TITLE = "Risk Matrix Calculator: 5x5 Likelihood x Severity";
export const RISK_MATRIX_DESCRIPTION =
  "Free 5x5 risk matrix calculator for construction RAMS. Pick likelihood and severity to get the risk score and band, before and after controls.";
export const RISK_ASSESSMENT_GUIDE_PATH = "/guides/risk-assessment-construction";
export const RISK_ASSESSMENT_MATRIX_ANCHOR = `${RISK_ASSESSMENT_GUIDE_PATH}#the-likelihood-severity-matrix`;
export const RAMS_GENERATOR_PATH = "/free/rams-generator";
